import { Tooltip, Typography } from "@mui/material";
import React from "react";
import { ScormExportFileDeliveryStatus } from "services/KnowfullyAdminClient";
import { ExportedScormFileRow, STATUS_MESSAGE_IDS, Translate } from "./types";

type StatusCellProps = {
  value: ExportedScormFileRow;
  t: Translate;
};

/**
 * The Status column: the status word, and under a Failed one the reason the last attempt gave.
 */
export const StatusCell = ({ value, t }: StatusCellProps) => (
  <>
    {value.status ? t({ id: STATUS_MESSAGE_IDS[value.status] }) : null}
    {value.status === ScormExportFileDeliveryStatus.Failed &&
      !!value.lastUploadError && (
        <Tooltip title={value.lastUploadError}>
          {/* The column is nvarchar(max) server side and these reasons quote a remote error
              verbatim, so an untruncated one pushes Actions off the row. Truncating is also
              what gives the tooltip something to add. */}
          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            noWrap
            sx={{ maxWidth: 320, textOverflow: "ellipsis" }}
          >
            {value.lastUploadError}
          </Typography>
        </Tooltip>
      )}
  </>
);
